<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :title="`选择导出字段`"
        :visible.sync="dialogVisible"
        center
        width="1000px">
        <div class="flex flex-direction">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-form class="publish-form"  ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label-width="0" prop="fields">
                    <el-checkbox-group v-model="ruleForm.fields" @change="handleCheckedChange">
                        <el-checkbox :label="item.value" v-for="(item,index) in fields" :key="index">{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "exportFieldsDialog",
    data() {
        return {
            checkAll: true,
            isIndeterminate: false,
            ruleForm: {
                fields: [],
            },
            rules: {
                fields: [
                    {required: true, message: '请选择导出字段', trigger: 'change'}
                ]
            },
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        fields: {
            type: Array,
            default: ()=>{
                return []
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        this.ruleForm.fields = this.fields.map(item=>{ return item.value})
    },
    methods: {
        cancel() {
            this.$emit('watchExportState', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('watchExportState', this.ruleForm.fields)
                }
            });
        },
        handleCheckAllChange(val) {
            this.ruleForm.fields = val ? this.fields.map(item=>{ return item.value}) : [];
            this.isIndeterminate = false;
        },
        handleCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount ===  this.fields.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount <  this.fields.length;
        }

    },
    filters: {

    },
    watch: {}
}
</script>

<style lang="scss" scoped>

.info-container {
    height: 130px;
    background-color: #f4f4f4;
    border-radius: 10px;
    padding: 25px;
    .title {
        font-size: 16px;
        color: #333333;
    }

    .tips {
        font-size: 12px;
        color: #666666;
    }

    .submit{
        width: 200px;
        height: 42px;
        background: #023e96;
        color: #FFFFFF;
    }
}

</style>